import VueRouter from 'vue-router';
import { routes } from './routes';

export class Router extends VueRouter {}

export function createRouter(): Router {
  return new Router({
    mode: 'abstract',
    routes
  });
}
